import { useRouter }                   from "next/router";
import { useEffect, useRef, useState } from "react";

import { useSetPipMode }  from "_common/hooks/player";
import { getTypeOfVideo } from "_common/utils";

import Presentation from "./presentation";

const component = ( { videoItem, previousRoute, userId, from, thumbnail, adTagURL } ) => {

	const router             = useRouter ();
	const rightSideRef       = useRef ();
	const togglePipModeVideo = useSetPipMode ();

	const { currentTime } = router.query;

	// state for infinite call logic

	const [ playlist, setPlaylist ] = useState ( [] );

	const [ collapse, setCollapse ] = useState ( false );

	useEffect ( () => {
		togglePipModeVideo ( {
			status     : false,
			sessionId  : undefined,
			sessionSrc : undefined
		} );
	}, [] );

	useEffect ( () => {
		setNewPlayList ();
	}, [ videoItem.id ] );

	const changeVideoSrc = () => {
		if ( !playlist?.length )
			return;

		const nextItem = playlist[0];

		const nextVideoRoute = `/video/${ nextItem.id }`;

		router.push ( nextVideoRoute );

		router.events.on ( "routeChangeComplete", setNewPlayList );

	};

	const setNewPlayList = () => {
		if ( !playlist?.length )
			return;

		setPlaylist ( prevState =>
			prevState.filter ( item =>
				parseInt ( item.id ) !== parseInt ( videoItem.id )
			) );

		router.events.off ( "routeChangeComplete", setNewPlayList );

	};

	let videoSrc, videoType;

	if ( videoItem ) {
		const videoData = getTypeOfVideo ( videoItem );

		videoSrc  = videoData.m3u8 ? videoData.m3u8 : videoData.mp4;
		videoType = videoData.m3u8 ? "live" : "video";
	}

	const toggleCollapse = options => {

		if ( options.openOnly ) {
			rightSideRef.current.scrollTo ( { top: 0, behavior: "smooth" } );
			setCollapse ( true );
		} else
			setCollapse ( prev => !prev );
	};

	return (
		<Presentation
			adTagURL = { adTagURL }
			changeVideoSrc = { changeVideoSrc }
			collapse = { collapse }
			currentTime = { currentTime }
			from = { from }
			playlist = { playlist }
			previousRoute = { previousRoute }
			rightSideRef = { rightSideRef }
			setPlaylist = { setPlaylist }
			thumbnail = { thumbnail }
			toggleCollapse = { toggleCollapse }
			userId = { userId }
			videoItem = { videoItem }
			videoSrc = { videoSrc }
			videoType = { videoType }
		/>
	);
};

export default component;
